<template>
  <div class="s-address" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnAddress.src" :src="btnAddress.src" :style="{...btnAddress.style}" alt="" @click="addressFun">
  </div>
</template>

<script>
import SAnimateImage from "@/components/BuilderComponents/AnimateImage/index.vue";
export default {
  name: 'SActivityAddress',
  components: { SAnimateImage },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnAddress: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 点击活动记录
    addressFun () {
      if (!window.$checkLogin()) return
      this.$MainWrap.openAddress(this.activityId)
    }
  }
}
</script>
<style lang="scss" scoped>
.s-address {
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
